import { useGenericTT } from "@dfp/react-typed-translations";

import { projectName } from "./projectName.ts";
import translations from "./translations/en.json";

export function useTT() {
  return useGenericTT(projectName, translations);
}
